import React from 'react';
import styled from 'styled-components';
import { XIcon } from '@commonsku/styles';

const CloseButton = styled(XIcon).attrs({
  size: 'huge',
  altText: ''
})`
  position: fixed;
  top: 2px;
  right: 2px;
  z-index: 1001;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 8px;
  color: black;
`;

const CloseButtonGalleryImage = ({ onClick }) => {
  return <CloseButton onClick={onClick} />;
};

export default CloseButtonGalleryImage;
